import { z } from 'zod';
export const baseHealthManagementSchema = z.object({
    medications: z
        .object({
        actions: z.array(z.string()).optional(),
        issuesIdentified: z.boolean().optional(),
        issues: z.array(z.string()).optional(),
        issuesDescription: z.string().optional(),
        issuesNotifications: z.array(z.string()).optional(),
    })
        .optional(),
    homeEnvironment: z
        .object({
        altered: z.boolean().optional(),
        details: z.array(z.string()).optional(),
    })
        .optional(),
    suspectedAbuse: z
        .object({
        identified: z.boolean().optional(),
        types: z.array(z.string()).optional(),
        otherDescription: z.string().optional(),
    })
        .optional(),
    barriersToHealthStatus: z
        .object({
        identified: z.boolean().optional(),
        barriers: z.array(z.string()).optional(),
    })
        .optional(),
    signsOfHeartFailure: z
        .object({
        present: z.boolean().optional(),
        actions: z.array(z.string()).optional(),
        comment: z.string().optional(),
    })
        .optional(),
    signsOfOtherComorbidity: z
        .object({
        present: z.boolean().optional(),
        actions: z.array(z.string()).optional(),
        comment: z.string().optional(),
    })
        .optional(),
    comment: z.string().optional(),
});
